module.exports = __webpack_public_path__ + "static/img/brees-2006-slide-4.ebb56bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-slide-4.jpg
// module id = HPGP
// module chunks = 1